import { useMutation } from "react-query";
import * as role from "services/role/roles";

export const useRoleList = () => {
    return useMutation((formData) => role.RoleList(formData));
}

export const useAddRole = () => {
    return useMutation((formData) => role.AddRole(formData));
}

export const useEditRole = () => {
    return useMutation((formData) => role.EditRole(formData));
}

export const useGetRoleById = () => {
    return useMutation((id) => role.RoleById(id));
}
export const useStatusRole = () => {
    return useMutation((formData) => role.statusRole(formData));
  };
export const useDeleteRoleById = () => {
    return useMutation((id) => role.DeleteRoleById(id));
}